import { compact, uniqBy } from 'lodash';
import { MinimumHoldingClassRealisation } from 'further-types/lp/realisation';

const getUniqueInvestorsWithUnitsRealised = <
  T extends MinimumHoldingClassRealisation,
>({
  holdingClassRealisations,
}: {
  holdingClassRealisations: Array<T>;
}): Array<
  NonNullable<
    NonNullable<T['unitsAllocationPerInvestment']>[number]['allocations']
  >[number]
> => {
  const holdingClassRealisationsWithUnitsRealised =
    holdingClassRealisations.filter(
      (holdingClassRealisation) =>
        holdingClassRealisation.unitsSold &&
        holdingClassRealisation.unitsSold > 0,
    );

  const uniqueInvestorsWithUnitsRealised = uniqBy(
    holdingClassRealisationsWithUnitsRealised.flatMap(
      (holdingClassRealisation) =>
        holdingClassRealisation.unitsAllocationPerInvestment?.flatMap(
          (investmentAllocation) => investmentAllocation.allocations,
        ),
    ),
    (item) => item?.commitmentId,
  );

  return compact(uniqueInvestorsWithUnitsRealised);
};

export default getUniqueInvestorsWithUnitsRealised;
